/**
 * Returns { start, end } Date objects for a given filter value.
 * Returns null for 'all' (no filtering).
 */
export function getDateRange(filter, customRange = {}) {
  const today = new Date()
  today.setHours(0, 0, 0, 0)

  switch (filter) {
    case 'today':
      return { start: today, end: today }

    case 'last7': {
      const start = new Date(today)
      start.setDate(today.getDate() - 6)
      return { start, end: today }
    }

    case 'last30': {
      const start = new Date(today)
      start.setDate(today.getDate() - 29)
      return { start, end: today }
    }

    case 'custom': {
      if (!customRange.start || !customRange.end) return null
      return {
        start: new Date(customRange.start),
        end: new Date(customRange.end),
      }
    }

    default:
      return null
  }
}

/**
 * Filter an array of entries by a date range.
 * If range is null, returns all entries.
 */
export function filterEntriesByDate(entries, filter, customRange) {
  const range = getDateRange(filter, customRange)
  if (!range) return entries

  return entries.filter((entry) => {
    const entryDate = new Date(entry.date)
    entryDate.setHours(0, 0, 0, 0)
    return entryDate >= range.start && entryDate <= range.end
  })
}

/**
 * Format a date string YYYY-MM-DD for display
 */
export function formatDate(dateStr) {
  return dateStr
}

/**
 * Get today's date as YYYY-MM-DD
 */
export function todayStr() {
  return new Date().toISOString().split('T')[0]
}
